export default __webpack_public_path__ + "static/media/Proreview-1.73cbcde3.jpg";